﻿<script setup lang="ts">
    import { onMounted, watch } from 'vue';
    import PreviewButtons from '@shared/components/Editor/PreviewButtons.vue';
    import NavIcons from '@cwd/Navigation/NavIcons.vue';
    import { useRoute } from 'vue-router';

    const emit = defineEmits<{
        (ev: 'close'): void;
    }>();

    const route = useRoute();

    const props = defineProps<{
        iframeSrc: string;
    }>();

    onMounted(async () => {
        watch(
            () => route?.name,
            () => {
                emit('close');
            }
        );
    });
</script>

<script lang="ts"></script>

<template>
    <Teleport to="body">
        <div class="slide-in-dialog slide-in-new" :class="{ in: iframeSrc }">
            <div class="editor-container editor-bg d-flex">
                <div class="canvas-container">
                    <div class="canvas-container-toolbar d-flex gap-sm p-relative">
                        <button
                            type="button"
                            class="btn btn-subtle btn-sm m-auto-r"
                            @click="$emit('close')"
                            v-tooltip.left="$Resources.TemplatesClosePreviewBtnText">
                            <NavIcons icon="close"></NavIcons>
                            <span class="sr-only">{{ $Resources.TemplatesClosePreviewBtnText }}</span>
                        </button>

                        <slot name="toolbar"></slot>
                    </div>

                    <PreviewButtons></PreviewButtons>

                    <div class="canvas-wrap">
                        <iframe ref="iframe" :src="iframeSrc" frameborder="0" style="width: 100%; height: 100%"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped lang="less"></style>

<style lang="less">
    .slide-in-new {
        max-width: 900px;
    }

    body:has(.slide-in-new) {
        overflow: auto !important;
    }

    .canvas-container-toolbar {
        background-color: var(--bg-color);
        padding: var(--ug-spacing-sm) var(--ug-spacing-md);
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
        z-index: 1;
    }

    /*
    body:has(.slide-in-new.in) {
        transition: margin-right var(--transition-duration-normal) ease-in-out;
        margin-right: 900px;
    }
    */
</style>
